import { render } from "./ProductDetailPage.vue?vue&type=template&id=75064940&ts=true"
import script from "./ProductDetailPage.vue?vue&type=script&lang=ts"
export * from "./ProductDetailPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__